export default function getAdjustmentItemByTypeTotal(items, reservedProductType) {
  if (items === undefined || reservedProductType === undefined) return 0

  return items
    .filter((item) => item.type === reservedProductType)
    .map(item => item.price)
    .reduce((a, b) => a + b, 0)
}

